export enum DishType {
  Side,
  Snack,
  Drink,
  MainCourse,
  Standalone,
  Dessert,
}
